import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/careers/careers-component.jsx");
